import * as React from 'react';
import { Segment } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { TagFilter } from '~/InfoCardsFilter/TagFilter';
var source = function (sourceId) { return sourceId.split(':'); };
var parsed = function (types) {
    return types.map(function (type) { return ({ type: InfoCardApi.TagType.type, value: type.infoCardType.value }); });
};
export var SourceFilter = function (_a) {
    var filter = _a.filter, sources = _a.sources, types = _a.types;
    return (<Segment data-testid='source-filters'>
		{sources.map(function (option) {
            var typeToKeep = types.filter(function (type) {
                return source(type.sourceId)[1] === option.value &&
                    filter.has({ value: type.infoCardType.value, type: InfoCardApi.TagType.type });
            });
            return (<TagFilter condition={{ type: InfoCardApi.TagType.source, value: option.value }} filter={filter.keep(parsed(typeToKeep), InfoCardApi.TagType.type)} key={option.value}>
					{option.title}
				</TagFilter>);
        })}
	</Segment>);
};
